/*---------------------------
| Data
---------------------------*/
export const moderatorIconKeys = {
    HEART: "heart",
    MATURE_AUDIENCE: "matureAudience",
    SAVE_FOR_LATER: "saveForLater",
    BLUR: "blur",
    EXPAND: "expand"
};

/* ActionBar ---------------------------*/
const getSelectMessage = (uploadSelectedCount, isCompOrSusp = false) => {
    if (uploadSelectedCount > 0) {
        return `${uploadSelectedCount} selected`;
    }
    return isCompOrSusp
        ? `Select an image to view details`
        : `Select an image to edit`;
};

export const actionBar = {
    getSelectMessage
};

/*---------------------------
| Helpers
---------------------------*/
/**
 * getBatchUploads
 * We get batch uploads as needed
 * This also adds at fetch any FE state needed
 * these control the Moderator Action Band at footer of each upload image
 * defaults to off for all - unless told otherwise by state manager
 */
export const footerActions = {
    [moderatorIconKeys.HEART]: false,
    [moderatorIconKeys.MATURE_AUDIENCE]: false,
    [moderatorIconKeys.SAVE_FOR_LATER]: false,
    [moderatorIconKeys.BLUR]: false,
    [moderatorIconKeys.EXPAND]: false
};

export const getBatchUploads = (allUploads = [], batchId) => {
    return allUploads
        .filter(u => u.photoBatchId === batchId)
        .map(u => {
            return {
                ...u,
                title: u.photoTitle,
                batchId: u.photoBatchId,
                footerActions: u.footerActions || footerActions
            };
        });
};

const everySelectedUploadHasModIconEnabled = (
    selectedUploadFooterActions,
    modIconKey
) => {
    if (selectedUploadFooterActions.length < 1) {
        return false;
    }

    return selectedUploadFooterActions.every(footerActions => {
        return footerActions?.[modIconKey];
    });
};

export const getActionBarIconActions = selectedUploadFooterActions => {
    return {
        [moderatorIconKeys.HEART]: everySelectedUploadHasModIconEnabled(
            selectedUploadFooterActions,
            moderatorIconKeys.HEART
        ),
        [moderatorIconKeys.MATURE_AUDIENCE]: everySelectedUploadHasModIconEnabled(
            selectedUploadFooterActions,
            moderatorIconKeys.MATURE_AUDIENCE
        ),
        [moderatorIconKeys.SAVE_FOR_LATER]: everySelectedUploadHasModIconEnabled(
            selectedUploadFooterActions,
            moderatorIconKeys.SAVE_FOR_LATER
        ),
        [moderatorIconKeys.BLUR]: everySelectedUploadHasModIconEnabled(
            selectedUploadFooterActions,
            moderatorIconKeys.BLUR
        ),
        [moderatorIconKeys.EXPAND]: false
    };
};
